/**
 * @file select2
 */
'use strict';
import { select2 } from '../../Libs/select2.min'

/**
 * @classname FormSelect2
 * @classdesc select2
 */
export default class Select2 {
	/**
	 * @constructor
	 * @param {jQuery} $e - .select2
	 */
	constructor($e) {
		console.log(`Select2.constructor/ ${$e.attr('name')}/ ${$e.val()}`);
		const selectedValue = $e.attr('data-selected-value');
		let option = {};
		// レビュー用オプションデータの取得
		if ($e.hasClass('review_rating')) {
			const data = this.getReviewData();
			option = {
				data: data,
				escapeMarkup: function(markup) {
					return markup;
				},
			};
		}
		$e.select2(option);
		if ($e.val() !== '' || selectedValue) {
			console.log(`select2 trigger/ ${$e.attr('name')}`);
			if (selectedValue) $e.val(selectedValue);
			$e.trigger('change');
		}
	};

	/**
	 * レビュー用オプションデータ取得
	 *
	 * @memberof Select2
	 * @return {undefined}
	 */
	getReviewData() {
		const optionData = [
			{ id: '', text: '選択してください' },
			{ id: '5.0', text: '<span class="review review-50"></span><span class="review-num">5.0</span>' },
			{ id: '4.5', text: '<span class="review review-45"></span><span class="review-num">4.5</span>' },
			{ id: '4.0', text: '<span class="review review-40"></span><span class="review-num">4.0</span>' },
			{ id: '3.5', text: '<span class="review review-35"></span><span class="review-num">3.5</span>' },
			{ id: '3.0', text: '<span class="review review-30"></span><span class="review-num">3.0</span>' },
			{ id: '2.5', text: '<span class="review review-25"></span><span class="review-num">2.5</span>' },
			{ id: '2.0', text: '<span class="review review-20"></span><span class="review-num">2.0</span>' },
			{ id: '1.5', text: '<span class="review review-15"></span><span class="review-num">1.5</span>' },
			{ id: '1.0', text: '<span class="review review-10"></span><span class="review-num">1.0</span>' }
		];
		return optionData;
	}
}
